<template>
  <div class="details-container">
    <!-- HIGHLIGHTED SECTION -->
    <div v-if="highlightedSections.length">
      <div v-for="section in highlightedSections" :key="section.key" class="important-order-details">
        <template v-if="isObject(section.value)">
          <span v-for="(val, key) in section.value" :key="key">
            <span v-if="val"> <b>{{ formatKey(key) }}:</b> <scraped-value-display :value="val" /> </span>
          </span>
        </template>

        <template v-else>
          <span v-if="section.value"> <b>{{ formatKey(section.key) }}:</b> <scraped-value-display :value="section.value" /> </span>
        </template>
      </div>
    </div>

    <!-- MAIN DETAILS SECTION -->
    <div class="tax-details-container">
      <div v-for="item in flatData" :key="item.key">
        <span class="capitalise"> <b>{{ formatKey(item.key) }}:</b> <scraped-value-display :value="item.value" /> </span>
      </div>
    </div>
  </div>
</template>

<script>
import scrapedValueDisplay from '@/components/commonComponents/scrappedValueDisplay.vue'

export default {
  name: 'CommonDetails',
  components: {
    scrapedValueDisplay
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    highlightKeys: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    highlightedSections () {
      return Object.entries(this.data || {})
        .filter(([key, value]) => this.highlightKeys.includes(key) && this.hasValue(value))
        .map(([key, value]) => ({ key, value }))
    },

    flatData () {
      const flatten = (obj) => {
        if (!obj || typeof obj !== 'object') return []

        return Object.entries(obj).flatMap(([key, value]) => {
          if (this.highlightKeys.includes(key)) return [] // skip highlighted keys
          if (Array.isArray(value)) return [] // skip arrays
          if (value === null || value === undefined || value === '') return [] // skip empty
          if (typeof value === 'object') {
          // flatten nested object
            return flatten(value)
          }
          return [{ key, value }]
        })
      }

      return flatten(this.data || [])
    }
  },
  methods: {
    isObject (val) {
      const isObject = val !== null && typeof val === 'object' && !Array.isArray(val)
      if (isObject) {
        Object.keys(val).forEach(key => {
          if (!this.hasValue(val[key])) {
            delete val[key]
          }
        })
      }
      return isObject && Object.keys(val).length > 0
    },
    isPrimitive (val) {
      return ['string', 'number', 'boolean'].includes(typeof val)
    },
    formatKey (key) {
      return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase())
    },
    hasValue (val) {
      if (val == null) {
        return false
      }

      if (Array.isArray(val)) {
        return val.length > 0
      }

      if (typeof val === 'object') {
        return Object.keys(val || {}).length > 0
      }

      return val !== ''
    }
  }
}
</script>

<style scoped>
.details-container {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: white;
}

.capitalise {
  text-transform: capitalize;
}

.tax-details-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.important-order-details {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.important-order-details span {
  font-size: 16px;
  text-transform: capitalize;
}
</style>
